import {PanelBody, SelectControl} from '@wordpress/components';
import {__, sprintf} from '@wordpress/i18n';
import {SetAttributes} from './Edit';
import {Taxonomy} from '@wordpress/api/taxonomies';
import {useSelect} from '@wordpress/data';
import {range} from 'lodash';
import {CONFIG} from '../../../globals/config';

export type DisplayPostsOptions = {
	'display-posts': string;
	'display-posts/limit': number;
	'display-posts/post-type': string;
}

type Props = {
	attributes: DisplayPostsOptions;
	setAttributes: SetAttributes;
	type?: Taxonomy<'edit'>;
};

const DisplayPosts = ( {attributes, setAttributes, type}: Props ) => {
	const postType = useSelect( select => {
		return select( 'core' ).getPostType( attributes[ 'display-posts/post-type' ] ?? 'post' ) ?? select( 'core' ).getPostType( 'post' );
	}, [ attributes[ 'display-posts/post-type' ] ] );


	return ( <PanelBody
		title={`${__( 'Display', 'advanced-sidebar-menu' )} ${postType?.labels?.name ?? __( 'Posts', 'advanced-sidebar-menu' )}`}
		initialOpen={'' !== attributes[ 'display-posts' ]}
	>
		<SelectControl
			value={attributes[ 'display-posts' ]}
			/* translators: {post type plural label} */
			label={sprintf( __( 'Display assigned %1$s under', 'advanced-sidebar-menu' ), postType?.labels?.name.toLowerCase() ?? '' )}
			options={Object.entries( CONFIG.displayPosts.options ).map( ( [ value, label ] ) => ( {
				value,
				label: sprintf( label, type?.labels?.name.toLowerCase() ?? '' ),
			} ) )}
			onChange={value => {
				setAttributes( {
					'display-posts': value,
				} );
			}} />

		{'' !== attributes[ 'display-posts' ] && <SelectControl
			value={attributes[ 'display-posts/post-type' ]}
			label={__( 'Post type', 'advanced-sidebar-menu' )}
			labelPosition={'side'}
			options={Object.entries( CONFIG.displayPosts.types ).map( ( [ value, label ] ) => ( {
				value,
				label,
			} ) )}
			onChange={value => {
				setAttributes( {
					'display-posts/post-type': value,
				} );
			}} />}

		{'' !== attributes[ 'display-posts' ] && <div className={'components-base-control'}>
			{__( 'Display', 'advanced-sidebar-menu' )}&nbsp;
			<select
				value={attributes[ 'display-posts/limit' ]}
				onChange={ev => setAttributes( {
					'display-posts/limit': parseInt( ev.target.value ),
				} )}
			>
				<option value="100">
					{__( '- All -', 'advanced-sidebar-menu' )}
				</option>
				{range( 1, 10 ).map( n => <option key={n} value={n}>
					{n}
				</option> )}
			</select>
			&nbsp;{postType?.labels?.name.toLowerCase()}
		</div>}
	</PanelBody> );
};

export default DisplayPosts;
